export enum WorkflowLevelPermissionType {
  CAN_ARCHIVE_WORKFLOWS = "krypton.can_archive_workflows",
  CAN_VIEW_PROGRESS_MAP = "krypton.can_view_progress_map",
  CAN_VIEW_WORKFLOW_PROFILE = "krypton.can_view_workflow_profile",
  CAN_VIEW_ACTIVITY_LOG = "krypton.can_view_activity_log"
}

export type PermissionsAPIResponse = {
  objects: {
    codename: string;
    name: string;
  }[];
};
